import React from 'react';

import '../../../../css/common/chat/ChatUnreadDivider.css';

/**
 * 「ここから未読」の区切り。バブルとバブルの間に入り、これより下（新しい側）が未読であることを示す。
 * 会話の背景から浮かせず、線＋小さなラベルだけの控えめな表現にする（装飾を足さない）。
 */
export default function ChatUnreadDivider() {
  return (
    <div className="chat-unread-divider" aria-hidden="false">
      <span className="chat-unread-divider__line" />
      <span className="chat-unread-divider__label">ここから未読</span>
      <span className="chat-unread-divider__line" />
    </div>
  );
}
